export default __webpack_public_path__ + "static/infinity-rewards-promo-f342cbae88a199df9b5cce5fb0fb9196.jpg";